import { render, staticRenderFns } from "./LanguageForm.vue?vue&type=template&id=c168bc34&scoped=true&"
import script from "./LanguageForm.vue?vue&type=script&lang=js&"
export * from "./LanguageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c168bc34",
  null
  
)

export default component.exports